import React from 'react';
import CountUp from 'react-countup';

function FactsCounter({ icon, number, text }) {
  return (
    <div className="counter-item d-flex align-items-center flex-wrap flex-sm-nowrap">
      <div className="counter-icon">
        <img alt="icon" src={icon} />
      </div>
      <div className="counter-content">
        <div className="d-flex align-items-center">
          <h2 className="counter-num counter-up">
            <CountUp className="counter-num" end={number} />
          </h2>
          <h2 className="counter-plus">+</h2>
        </div>
        <h5 className="counter-text">{text}</h5>
      </div>
    </div>
  );
}

export default FactsCounter;
